module.exports = __webpack_public_path__ + "img/71eccd4.png";